import type { ReactNode } from 'react';

export const symbol_fork_spoon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M251.5-88.63Q243-97.25 243-110v-343.26Q186-468 153-508.5T120-603v-247q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v217h63v-217q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v217h64v-217q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v246.53Q427-548 394-508t-91 54.74V-110q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm413 0Q656-97.25 656-110v-359.05Q599-488 565.5-542.5T532-672q0-86.91 45.24-147.46Q622.47-880 686-880q63.53 0 108.76 60.75Q840-758.5 840-672q0 75-33.5 129.5T716-468v358q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
